import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Margin, Text } from 'shared/components'

import { ResetForm } from './components/resetForm'
import MobileResetForm from './components/mobileResetForm'
import * as styles from './styles'

const ResetPasswordComponent = ({ onSubmit }) => (
  <>
    {/* Mobile and Tablet View */}
    <div css={styles.mobileView}>
      <MobileResetForm onSubmit={onSubmit} />
    </div>

    {/* Desktop View */}
    <div css={styles.desktopView}>
      <Grid>
        <Row middle="xs" css={{ margin: 0 }}>
          <Col xs={12}>
            <Margin top={4} resetWhen="phone">
              <section css={styles.resetSection}>
                <Margin as="section" bottom={2}>
                  <Text as="h2" size={24}>
                    Reset Password
                  </Text>
                </Margin>
                <section>
                  <Text block maxCh={30}>
                    Enter the email address associated with your InWin account.
                  </Text>
                </section>
                <Margin as="section" tb={2}>
                  <ResetForm onSubmit={onSubmit} />
                </Margin>
              </section>
            </Margin>
          </Col>
        </Row>
      </Grid>
    </div>
  </>
)

ResetPasswordComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default ResetPasswordComponent
